import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { SITE_URL } from "@/lib/seo";
import { getSeoRoutes } from "@/lib/seoRoutes";

// Bridge to the Node build scripts: CRA has no "type": "module", so scripts/ cannot
// import these ESM modules directly. The prerenderer reads them off the page instead.
window.__SEO_ROUTES__ = getSeoRoutes();
window.__SEO_SITE_URL__ = SITE_URL;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
